import React, { useCallback, useState, useEffect } from "react";
import SearchInput from "./SearchInput";
import { producaov2 } from "../../../../../../services/apis";
import {
  Box,
  FormControl,
  Input,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@material-ui/core";

export default function TestSelect({
  courseID,
  selectedTest,
  onChangeSelectedTest,
}) {
  const [tests, setTests] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getTests = async () => {
      if (!courseID) {
        return;
      }

      setLoading(true);

      try {
        const response = await producaov2.get(
          `admin/testesV2?courseID=${courseID}`
        );
        const loadedTests = response.data?.map((test) => ({
          id: test?.js_id,
          name: `[${test?.moduleName}] ${test?.name}`,
          questions: test?.questions,
        }));

        setTests(loadedTests);
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };

    getTests();
  }, [courseID]);

  const handleChangeSelectedTest = (e) => {
    const testID = e.target.value;

    onChangeSelectedTest(tests.find((test) => test.id === testID));
  };

  if(tests?.length === 0 && !loading) {
    return (
      <Box p={2}>
        <Typography variant="h6">Nenhum teste encontrado nesse curso</Typography>
      </Box>
    )
  }

  return (
    <FormControl variant="outlined">
      <InputLabel>
        {loading ? "Carregando testes..." : "Selecione o teste"}
      </InputLabel>
        <Select
          disabled={loading}
          label={loading ? "Carregando testes..." : "Selecione o teste"}
          value={selectedTest?.id}
          onChange={handleChangeSelectedTest}
        >
          {tests?.map((test) => {
            return <MenuItem value={test?.id}>{test?.name}</MenuItem>;
          })}
        </Select>
    </FormControl>
  );
}
